import * as yup from 'yup';

export const PROFIT_IQ_STATES = {
  allowed: 'allowed',
  disabled: 'disabled',
  trial: 'trial',
};

/**
 * Mirrors the backend validator: a trial needs both a start date and a length,
 * because the expiry it is stored with is computed from them.
 */
export const profitIqSettingsSchema = yup.object().shape({
  state: yup
    .string()
    .oneOf(Object.values(PROFIT_IQ_STATES))
    .required('State is required'),
  trialStart: yup
    .date()
    .nullable()
    .when('state', {
      is: PROFIT_IQ_STATES.trial,
      then: (schema) => schema.required('Trial start date is required'),
    }),
  trialPeriodInDay: yup
    .number()
    .nullable()
    .transform((value, original) => (original === '' ? null : value))
    .when('state', {
      is: PROFIT_IQ_STATES.trial,
      then: (schema) =>
        schema
          .required('Trial length is required')
          .integer('Trial length must be a whole number of days')
          .min(1, 'Trial length must be at least 1 day'),
    }),
});
